import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { MiniAppAccountChoiceItem } from './MiniAppAccountChoiceItem'
/**
* Class MiniAppAccountChoiceResponse
*  Если значение присутствует, нужно выбрать аккаунт (только Telegram)<br>
*/
export class MiniAppAccountChoiceResponse extends ActiveModel {

/**
  * token
  * Защищённый токен для `POST auth/mini-app/select`
  */
  @ActiveField('')
  token: string = ''


/**
  * @property accounts
  * Аккаунты пула, связанные с этим Telegram user id<br>  */
  @ActiveField({
    factory: [MiniAppAccountChoiceItem, () => []]
  })
  accounts: Array<MiniAppAccountChoiceItem> = []
}
